import { UserType } from '@/types/user'

export function hasUserAddress(user?: Partial<UserType> | null) {
  if (!user) return false
  return Boolean(user.cep || user.id_address)
}
